import React from 'react';
import { Container, Paper, Box, Typography } from '@mui/material';
import logoImage from '../../assets/Chattitude_Main_Logo_v5.svg';
import { useReseller } from '../../contexts/ResellerContext';
import { BASE_URL } from '../../common/Constants';

export default function AuthLayout({ children, title, centered = false }) {
    const { reseller, resellerResolved } = useReseller();
    const logoSrc =
        reseller?.logoPath
            ? reseller.logoPath.startsWith('http://') || reseller.logoPath.startsWith('https://')
                ? reseller.logoPath
                : `${BASE_URL}/api/public/reseller/${reseller.id}/logo`
            : logoImage;

    return (
        <Container maxWidth="sm" sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Box sx={centered ? { flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' } : { mt: 4, mb: 2 }}>
                <Paper elevation={4} sx={{ width: '100%', overflow: 'hidden' }}>
                    <Box sx={{ p: 3 }}>
                        <Box sx={{ textAlign: 'center', mb: 1, minHeight: 72 }}>
                            {resellerResolved ? (
                                <img
                                    src={logoSrc}
                                    alt={reseller?.name || 'Powered With Chattitude'}
                                    width={320}
                                    style={{ maxWidth: '100%', height: 'auto' }}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = logoImage;
                                    }}
                                />
                            ) : (
                                <Box
                                    sx={{ width: 320, maxWidth: '100%', height: 72, mx: 'auto' }}
                                    aria-hidden
                                />
                            )}
                        </Box>
                        {title && (
                            <Typography variant="h6" align="center" sx={{ mb: 2 }}>
                                {title}
                            </Typography>
                        )}
                        <Box sx={{ maxWidth: 420, mx: 'auto', width: '100%' }}>{children}</Box>
                    </Box>
                </Paper>
            </Box>
        </Container>
    );
}
